import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useSubscriptionAPIClient = () => {
  const { get, set } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getSubscriptionStatus = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/subscription`),
    );
  }, [activeUser, get]);

  const cancelSubscription = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      set(`users/${activeUser.userId}/subscription/cancel`),
    );
  }, [activeUser, set]);

  const getBillingPortalLink = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      set(`users/${activeUser.userId}/subscription/billingPortal`),
    );
  }, [activeUser, set]);

  const getCheckoutLink = useCallback(async () => {
    const response = await withNetworkErrorHandling(() =>
      set(`users/${activeUser.userId}/subscription/checkoutSession`),
    );
    return response?.url;
  }, [activeUser, set]);

  return {
    getSubscriptionStatus,
    getBillingPortalLink,
    getCheckoutLink,
    cancelSubscription,
  };
};

export default useSubscriptionAPIClient;
